<template>
  <div class="">
    <button v-if="areaLevel === 'district' || areaLevel === 'zone'" class="bg-white hover:bg-grey-lightest text-black text-sm font-bold py-2 px-3 rounded flex items-center" @click="showProvinces">
      <div class="mr-1"><v-icon scale="0.7" name="level-up-alt" class="text-button-icon" /></div>
      <div class="">Provinsi</div>
    </button>
    <button v-if="areaLevel === 'school'" class="bg-white hover:bg-grey-lightest text-black text-sm font-bold py-2 px-3 rounded flex items-center" @click="showDistricts">
      <div class="mr-1"><v-icon scale="0.7" name="level-up-alt" class="text-button-icon" /></div>
      <div class="">Kota/Kabupaten</div>
    </button>
  </div>
</template>

<script>
export default {
  name: 'level-button',
  props: {
    areaLevel: String,
    showProvinces: Function,
    showDistricts: Function
  }
}
</script>
